import * as React from 'react';
import { ContextsService } from '../../../../../shared/Contexts.service';
import Dropdown from './Dropdown';
import type { SelectEvent } from './Dropdown';

type Props = {
  updateGranularity: (value: SelectEvent) => void;
  granularity: string;
  context?: string;
};

export default class GranularitySelector extends React.Component<Props> {
  render() {
    const timeseriesOptions = [
      {
        label: 'Day',
        value: 'day',
      },
      {
        label: 'Week',
        value: 'week',
      },
      {
        label: 'Month',
        value: 'month',
      },
    ];
    const tableOptions = [
      ...timeseriesOptions,
      {
        label: 'All Time',
        value: 'all',
      },
    ];
    const { updateGranularity, granularity, context } = this.props;
    const contextIsTable = ContextsService.isTableContext(context);
    return (
      <div className="h_miw-100">
        <Dropdown
          options={contextIsTable ? tableOptions : timeseriesOptions}
          onChange={updateGranularity}
          value={granularity}
          clearable={false}
          testid="granularity-selector"
        />
      </div>
    );
  }
}
